export const palette = {
  blue: "#0453F4",
  // chatBlue: "#226FFF",
  skyBlue: "#99CAFF",
  brightBlue: "#E9F1FF",
  green: "#34C759",
  lightGreen: "#51D888",

  chatGray: "#F7F8FA",
  lineGray: "#ddd",
  // outlineGray: "#E6E6E6",
  outlineGray: "#E0E4EB",
  buttonLineGray: "#B3B3B3",
  lightGray: "#aaa",
  gray: "#7a7a7a",
  darkGray: "#3D3D3D",

  gray50: "#fafafa",
  gray100: "#f6f6f6",
  gray200: "#ddd",
  gray300: "#ccc",
  gray400: "#999",
  gray500: "#8c8c8c",
  gray600: "#6C757D",
  gray700: "#666",
  gray800: "#323232",
  gray900: "#212121",

  red: "#FC3030",
  yellow: "#FFCC33",

  white: "#fff",
  black: "#000",

  primary: "#226FFF",
  primaryLightest: "#F0F4FF",
  mainLight: "#8183ff",
  main: "#4c4fff",
  mainDark: "#3537b3",

  secondaryLight: "#5aebb3",
  secondary: "#14e293",
  secondaryDark: "#10b576",

  warningLight: "#fcd64c",
  warning: "#fbc400",
  warningDark: "#d6a700",

  errorLight: "#ff6d78",
  error: "#ff2f3e",
  errorDark: "#cc2632",

  purpleChip: "#7380d8",
  greenChip: "#3cd7a9",


};
